export default __webpack_public_path__ + "static/media/27-MichaelEaston.7345570a.jpg";